import { render, staticRenderFns } from "./PhysiologicalAge.vue?vue&type=template&id=3f34bb25&scoped=true&"
import script from "./PhysiologicalAge.vue?vue&type=script&lang=js&"
export * from "./PhysiologicalAge.vue?vue&type=script&lang=js&"
import style0 from "./PhysiologicalAge.vue?vue&type=style&index=0&id=3f34bb25&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f34bb25",
  null
  
)

export default component.exports